var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.172,
    height: 13.942,
    viewBox: "0 0 32.172 13.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.145,86.4a9.618,9.618,0,0,0-2.958,4.822,1.088,1.088,0,0,1-2.123-.476A11.548,11.548,0,0,1,24.1,85.366a19.174,19.174,0,0,0-3.211-1.042,13.126,13.126,0,0,0-1.916,1.142,10.156,10.156,0,0,0-4.107,5.76,1.088,1.088,0,0,1-2.123-.476,12.271,12.271,0,0,1,4.784-6.92c-.474-.031-.954-.048-1.439-.048-.551,0-1.095.023-1.632.063a13.316,13.316,0,0,0-3.02,1.621,10.154,10.154,0,0,0-4.107,5.76A1.088,1.088,0,0,1,5.2,90.751a11.6,11.6,0,0,1,3.144-5.5,14.8,14.8,0,0,0-8,7.22,3.686,3.686,0,0,0,3.342,5.25H28.484a3.689,3.689,0,0,0,3.342-5.251A14.107,14.107,0,0,0,26.145,86.4Z",
    transform: "translate(-0.001 -83.783)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBread);
export default __webpack_public_path__ + "static/media/bread.51eb4e6baea816bd86887fbc59b53832.svg";
export { ForwardRef as ReactComponent };